var _path, _path2, _path3, _path4, _path5, _path6, _mask, _g, _mask2, _g2, _mask3, _g3, _mask4, _g4, _mask5, _g5, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _g6, _g7, _g8, _g9, _g10, _g11, _path28, _path29, _path30, _mask6, _g12, _path31, _path32, _path33, _path34, _path35, _mask7, _g13, _path36, _path37, _path38, _path39, _path40;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMcControlsPanel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 660,
    height: 438,
    viewBox: "0 0 660 438",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M613.907 296.07L600.199 423.006L528.071 -156.782H661.558L613.907 296.07ZM140.012 278.182L152.251 425.878L225.848 -156.459H92.0352L140.012 278.182Z",
    fill: "#E4E4E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M600.524 423.343C533.943 431.473 458.877 437.001 377.284 437.326C295.364 437.326 219.972 432.123 153.065 423.993C153.065 376.842 153.065 329.365 153.065 282.214L600.524 281.563V423.343Z",
    fill: "#9F9F9F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97.583 -127.843C97.583 -127.843 156.983 37.0248 161.226 81.5748C164.49 114.743 155.351 240.914 150.455 304.325C148.823 326.437 161.552 346.599 181.461 352.452C231.722 367.41 298.303 381.068 376.959 381.393C455.941 381.393 523.174 367.736 574.088 352.777C594.65 346.599 608.031 325.137 605.42 302.374C602.809 279.936 600.198 253.922 597.261 224.655C591.06 164.171 586.164 99.4598 590.407 81.2496C598.893 44.8292 648.175 -128.168 648.175 -128.168L97.583 -127.843Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M140.011 -75.4854L610.315 -75.8105C609.989 -75.8105 375.979 277.988 140.011 -75.4854Z",
    fill: "#D0D0D0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M164.328 58.3927C160.819 34.2691 185.031 17.1378 204.331 29.724C241.175 53.8477 278.375 94.6169 369.253 94.6169C460.132 94.6169 492.769 56.295 530.666 32.521C548.562 20.9836 578.128 36.0171 577.075 58.3927C577.075 59.4416 577.075 60.4904 577.075 61.5393C576.724 75.8736 583.301 231.667 589.266 288.655C590.67 302.64 582.6 315.576 570.318 319.072C520.841 334.105 454.171 348.44 374.517 348.44C294.863 348.44 228.192 334.455 179.066 319.421C167.136 315.575 159.065 303.339 160.118 290.053C162.574 255.441 164.679 227.472 166.083 207.543C169.592 153.353 167.486 80.7682 166.083 68.5316C165.381 65.7347 165.03 62.2385 164.328 58.3927Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M582.6 244.423C539.088 266.449 437.327 312.249 354.164 286.727C339.778 282.532 294.512 268.547 290.301 240.577C287.845 223.096 302.583 210.86 298.372 203.867C293.81 195.477 264.685 198.274 164.679 244.074C163.276 262.254 161.521 285.328 159.767 312.249C158.714 325.884 166.785 338.121 178.715 341.617C227.841 356.651 294.863 370.635 374.166 370.635C453.82 370.635 520.49 356.301 569.967 341.267C582.249 337.422 590.319 324.486 588.916 310.851C587.512 294.419 585.056 270.295 582.6 244.423Z",
    fill: "#54BCE3"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 504,
    y: 129,
    width: 34,
    height: 68
  }, /*#__PURE__*/React.createElement("path", {
    d: "M504.937 132.077C504.937 130.535 506.169 129.285 507.687 129.285H535.188C536.706 129.285 537.938 130.535 537.938 132.077V193.493C537.938 195.035 536.706 196.285 535.188 196.285H507.688C506.169 196.285 504.938 195.035 504.938 193.493L504.937 132.077Z",
    fill: "#80CCE8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M504.937 132.066C504.937 130.53 506.184 129.285 507.722 129.285H535.566C537.103 129.285 538.35 130.53 538.35 132.066V193.238C538.35 194.773 537.103 196.018 535.566 196.018H507.722C506.184 196.018 504.938 194.773 504.938 193.238L504.937 132.066Z",
    fill: "#80CCE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.938 165.432C504.938 163.897 506.184 162.652 507.722 162.652H535.566C537.103 162.652 538.35 163.897 538.35 165.432V193.238C538.35 194.773 537.103 196.018 535.566 196.018H507.722C506.184 196.018 504.938 194.773 504.938 193.238V165.432Z",
    fill: "#80CCE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.938 164.042C504.938 163.274 505.769 162.652 506.794 162.652C507.819 162.652 508.65 163.274 508.65 164.042V194.628C508.65 195.396 507.819 196.018 506.794 196.018C505.769 196.018 504.938 195.396 504.938 194.628V164.042Z",
    fill: "#A9E1F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.65 192.311H536.958C537.727 192.311 538.35 193.141 538.35 194.165C538.35 195.189 537.727 196.018 536.958 196.018H504.938L508.65 192.311Z",
    fill: "#68B1CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.494 196.018C535.469 196.018 534.638 195.326 534.638 194.473L534.638 160.489C534.638 159.636 535.469 158.944 536.494 158.944C537.519 158.944 538.35 159.636 538.35 160.489L538.35 194.473C538.35 195.326 537.519 196.018 536.494 196.018Z",
    fill: "#68B1CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.938 164.042C499.369 162.652 505.562 162.652 506.331 162.652H538.351L534.638 166.359H508.651C507.882 166.359 504.938 164.81 504.938 164.042Z",
    fill: "#A9E1F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.938 132.066C504.938 130.53 506.184 129.285 507.722 129.285H535.566C537.103 129.285 538.35 130.53 538.35 132.066V159.871C538.35 161.407 537.103 162.652 535.566 162.652H507.722C506.184 162.652 504.938 161.407 504.938 159.871V132.066Z",
    fill: "#80CCE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.938 127.896C504.938 127.043 505.769 126.352 506.794 126.352C507.819 126.352 508.65 127.043 508.65 127.896V162.653C508.65 162.653 507.819 162.653 506.794 162.653C505.769 162.653 504.938 162.653 504.938 162.653V127.896Z",
    fill: "#A9E1F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.65 158.945H534.637C535.406 158.945 538.35 160.494 538.35 161.262C538.35 162.03 537.727 162.652 536.958 162.652L504.938 162.652L508.65 158.945Z",
    fill: "#68B1CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.494 162.652C535.469 162.652 534.638 162.652 534.638 162.652L534.638 127.122C534.638 126.269 535.469 125.578 536.494 125.578C537.519 125.578 538.35 126.269 538.35 127.122L538.35 162.652C538.35 162.652 537.519 162.652 536.494 162.652Z",
    fill: "#68B1CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.938 131.139C504.938 130.115 505.561 129.285 506.33 129.285H538.35L534.637 132.993H506.33C505.561 132.993 504.938 132.163 504.938 131.139Z",
    fill: "#A9E1F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M510.506 148.269L521.788 137.626V143.667L510.506 154.31V148.269ZM532.781 148.269L521.788 137.626V143.667L532.781 154.31V148.269Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M532.781 177.034L521.499 187.677L521.499 181.636L532.781 170.994L532.781 177.034ZM510.506 177.034L521.499 187.677L521.499 181.636L510.506 170.994L510.506 177.034Z",
    fill: "#333333"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 352,
    y: 210,
    width: 34,
    height: 68
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.725 213.641C352.725 212.099 353.956 210.849 355.475 210.849H382.975C384.493 210.849 385.725 212.099 385.725 213.641V275.057C385.725 276.599 384.493 277.849 382.975 277.849H355.475C353.956 277.849 352.725 276.599 352.725 275.057L352.725 213.641Z",
    fill: "#80CCE8"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.725 213.63C352.725 212.094 353.971 210.849 355.509 210.849H383.353C384.891 210.849 386.137 212.094 386.137 213.63V274.802C386.137 276.337 384.891 277.582 383.353 277.582H355.509C353.971 277.582 352.725 276.337 352.725 274.802L352.725 213.63Z",
    fill: "#80CCE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.725 246.996C352.725 245.46 353.971 244.216 355.509 244.216H383.353C384.891 244.216 386.137 245.46 386.137 246.996V274.802C386.137 276.337 384.891 277.582 383.353 277.582H355.509C353.971 277.582 352.725 276.337 352.725 274.802V246.996Z",
    fill: "#80CCE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.725 245.606C352.725 244.838 353.556 244.216 354.581 244.216C355.606 244.216 356.437 244.838 356.437 245.606V276.192C356.437 276.96 355.606 277.582 354.581 277.582C353.556 277.582 352.725 276.96 352.725 276.192V245.606Z",
    fill: "#A9E1F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.437 273.875H384.745C385.514 273.875 386.137 274.705 386.137 275.729C386.137 276.752 385.514 277.582 384.745 277.582H352.725L356.437 273.875Z",
    fill: "#68B1CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.281 277.582C383.256 277.582 382.425 276.89 382.425 276.037L382.425 242.053C382.425 241.2 383.256 240.508 384.281 240.508C385.306 240.508 386.137 241.2 386.137 242.053L386.137 276.037C386.137 276.89 385.306 277.582 384.281 277.582Z",
    fill: "#68B1CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.725 245.606C347.156 244.216 353.349 244.216 354.118 244.216H386.138L382.425 247.923H356.438C355.669 247.923 352.725 246.374 352.725 245.606Z",
    fill: "#A9E1F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.725 213.63C352.725 212.094 353.971 210.849 355.509 210.849H383.353C384.891 210.849 386.137 212.094 386.137 213.63V241.435C386.137 242.971 384.891 244.216 383.353 244.216H355.509C353.971 244.216 352.725 242.971 352.725 241.435V213.63Z",
    fill: "#80CCE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.725 209.46C352.725 208.607 353.556 207.916 354.581 207.916C355.606 207.916 356.437 208.607 356.437 209.46V244.217C356.437 244.217 355.606 244.217 354.581 244.217C353.556 244.217 352.725 244.217 352.725 244.217V209.46Z",
    fill: "#A9E1F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.437 240.509H382.425C383.193 240.509 386.137 242.058 386.137 242.826C386.137 243.593 385.514 244.216 384.745 244.216L352.725 244.216L356.437 240.509Z",
    fill: "#68B1CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.281 244.216C383.256 244.216 382.425 244.216 382.425 244.216L382.425 208.686C382.425 207.833 383.256 207.142 384.281 207.142C385.306 207.142 386.137 207.833 386.137 208.686L386.137 244.216C386.137 244.216 385.306 244.216 384.281 244.216Z",
    fill: "#68B1CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.725 212.703C352.725 211.679 353.348 210.849 354.117 210.849H386.137L382.425 214.557H354.117C353.348 214.557 352.725 213.727 352.725 212.703Z",
    fill: "#A9E1F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M358.293 229.833L369.575 219.19V225.231L358.293 235.873V229.833ZM380.568 229.833L369.575 219.19V225.231L380.568 235.873V229.833Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M380.568 258.598L369.286 269.241L369.286 263.2L380.568 252.558L380.568 258.598ZM358.293 258.598L369.286 269.241L369.286 263.2L358.293 252.558L358.293 258.598Z",
    fill: "#333333"
  }))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 211,
    y: 129,
    width: 291,
    height: 68
  }, /*#__PURE__*/React.createElement("rect", {
    x: 211.649,
    y: 129.285,
    width: 289.575,
    height: 66.7332,
    fill: "#4873E2"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 211.649,
    y: 129.285,
    width: 285.863,
    height: 66.7332,
    fill: "#1E4BBF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M341.587 199.727L428.831 112.603H490.087L395.418 207.142L341.587 199.727ZM484.518 127.431L412.124 199.726H425.118L497.512 127.431H484.518Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.087 194.166C193.087 193.142 193.918 192.312 194.943 192.312H499.368C500.393 192.312 501.224 193.142 501.224 194.166C501.224 195.189 500.393 196.019 499.368 196.019H194.943C193.918 196.019 193.087 195.189 193.087 194.166Z",
    fill: "#1C3B8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.512 116.31C497.512 115.287 498.343 114.457 499.368 114.457C500.393 114.457 501.224 115.287 501.224 116.31V194.166C501.224 195.189 500.393 196.019 499.368 196.019C498.343 196.019 497.512 195.189 497.512 194.166V116.31Z",
    fill: "#1C3B8B"
  }))), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "mask3",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 211,
    y: 210,
    width: 139,
    height: 68
  }, /*#__PURE__*/React.createElement("rect", {
    x: 211.649,
    y: 210.849,
    width: 137.363,
    height: 66.7332,
    fill: "#4873E2"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 211.649,
    y: 210.849,
    width: 285.863,
    height: 66.7332,
    fill: "#1E4BBF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M252.487 281.289L339.731 194.165H400.987L306.319 288.703L252.487 281.289ZM395.419 208.993L323.025 281.288H336.019L408.412 208.993H395.419Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.225 275.729C204.225 274.706 205.056 273.876 206.081 273.876H347.156C348.181 273.876 349.012 274.706 349.012 275.729C349.012 276.753 348.181 277.583 347.156 277.583H206.081C205.056 277.583 204.225 276.753 204.225 275.729Z",
    fill: "#1C3B8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.3 201.581C345.3 200.558 346.131 199.728 347.156 199.728C348.181 199.728 349.012 200.558 349.012 201.581V275.729C349.012 276.753 348.181 277.583 347.156 277.583C346.131 277.583 345.3 276.753 345.3 275.729V201.581Z",
    fill: "#1C3B8B"
  }))), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "mask4",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 400,
    y: 210,
    width: 139,
    height: 68
  }, /*#__PURE__*/React.createElement("rect", {
    x: 400.987,
    y: 210.849,
    width: 137.362,
    height: 66.7332,
    fill: "#4873E2"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 400.987,
    y: 210.849,
    width: 285.862,
    height: 66.7332,
    fill: "#1E4BBF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M297.037 281.289L384.281 194.165H445.537L350.868 288.703L297.037 281.289ZM439.968 208.993L367.575 281.288H380.568L452.962 208.993H439.968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.562 275.729C393.562 274.706 394.394 273.876 395.419 273.876H536.494C537.519 273.876 538.35 274.706 538.35 275.729C538.35 276.753 537.519 277.583 536.494 277.583H395.419C394.394 277.583 393.562 276.753 393.562 275.729Z",
    fill: "#1C3B8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.637 201.581C534.637 200.558 535.469 199.728 536.494 199.728C537.519 199.728 538.35 200.558 538.35 201.581V275.729C538.35 276.753 537.519 277.583 536.494 277.583C535.469 277.583 534.637 276.753 534.637 275.729V201.581Z",
    fill: "#1C3B8B"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M453.386 149.212C453.386 153.735 455.651 157.715 459.215 159.135L458.527 160.857C454.074 159.082 451.529 154.275 451.529 149.212V148.014H453.386V149.212Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M454.862 150.009L453.259 144.018L449.25 148.412L454.862 150.009Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M466.838 159.183C470.183 157.331 472.774 153.63 472.774 149.209H474.63C474.63 154.374 471.609 158.661 467.738 160.804L466.838 159.183Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M467.288 156.401L462.879 160.794L468.892 162.791L467.288 156.401Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M462.88 138.553C460.77 138.553 458.566 139.615 456.644 141.146L455.486 139.698C457.573 138.034 460.179 136.699 462.88 136.699C465.492 136.699 468.102 137.567 470.274 139.298L469.116 140.747C467.279 139.283 465.078 138.553 462.88 138.553Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M466.487 142.017L472.5 144.014L471.297 137.623L466.487 142.017Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M405.057 216.781H406.779V225.679H408.353V216.781H410.076V215.298H405.057V216.781Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M411.29 225.679H412.864V215.298H411.29V225.679Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M419.482 215.298L418.175 221.927L416.809 215.298H414.582V225.679H416.126V218.56L417.596 225.679H418.695L420.165 218.56V225.679H421.739V215.298H419.482Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M423.457 225.679H427.927V224.196H425.031V221.156H427.333V219.673H425.031V216.781H427.927V215.298H423.457V225.679Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M432.216 225.679H436.597V224.196H433.79V215.298H432.216V225.679Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M437.814 225.679H442.284V224.196H439.388V221.156H441.69V219.673H439.388V216.781H442.284V215.298H437.814V225.679Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M443.6 225.679H445.174V221.304H447.402V219.821H445.174V216.781H447.996V215.298H443.6V225.679Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M448.852 216.781H450.575V225.679H452.149V216.781H453.872V215.298H448.852V216.781Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M218.407 225.825C219.906 225.825 220.946 224.758 220.946 223.275C220.946 222.133 220.456 221.377 218.941 219.864C217.827 218.752 217.501 218.277 217.501 217.625C217.501 216.972 217.813 216.631 218.362 216.631C218.911 216.631 219.223 217.046 219.223 217.847V218.144L220.738 217.981V217.714C220.738 216.157 219.847 215.148 218.347 215.148C216.847 215.148 215.956 216.157 215.956 217.699C215.956 218.841 216.402 219.642 217.961 221.11C219.134 222.222 219.401 222.696 219.401 223.349C219.401 223.957 219.015 224.342 218.392 224.342C217.768 224.342 217.382 223.883 217.382 223.126V222.741L215.867 222.904V223.275C215.867 224.758 216.907 225.825 218.407 225.825Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M222.285 225.677H226.755V224.194H223.859V221.154H226.161V219.671H223.859V216.779H226.755V215.296H222.285V225.677Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M227.567 216.779H229.289V225.677H230.863V216.779H232.586V215.296H227.567V216.779Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M236.268 216.779H237.991V225.677H239.565V216.779H241.287V215.296H236.268V216.779Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M242.501 225.677H244.075V215.296H242.501V225.677Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M250.694 215.296L249.387 221.925L248.021 215.296H245.793V225.677H247.337V218.559L248.808 225.677H249.906L251.377 218.559V225.677H252.951V215.296H250.694Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M254.668 225.677H259.138V224.194H256.242V221.154H258.544V219.671H256.242V216.779H259.138V215.296H254.668V225.677Z",
    fill: "white"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.904 270.167V265.644H227.775V270.167H229.349V259.786H227.775V264.161H225.904V259.786H224.33V270.167H225.904Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.648 270.167V265.644H234.519V270.167H236.093V259.786H234.519V264.161H232.648V259.786H231.073V270.167H232.648Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M415.242 270.167V265.644H417.113V270.167H418.687V259.786H417.113V264.161H415.242V259.786H413.668V270.167H415.242Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.985 270.167V265.644H423.857V270.167H425.431V259.786H423.857V264.161H421.985V259.786H420.411V270.167H421.985Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269.792 259.786L268.485 266.415L267.119 259.786H264.892V270.167H266.436V263.048L267.906 270.167H269.005L270.475 263.048V270.167H272.049V259.786H269.792Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.667 259.786L277.36 266.415L275.994 259.786H273.767V270.167H275.311V263.048L276.781 270.167H277.88L279.35 263.048V270.167H280.924V259.786H278.667Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M459.13 259.786L457.823 266.415L456.457 259.786H454.229V270.167H455.774V263.048L457.244 270.167H458.343L459.813 263.048V270.167H461.387V259.786H459.13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.005 259.786L466.698 266.415L465.332 259.786H463.105V270.167H464.649V263.048L466.119 270.167H467.218L468.688 263.048V270.167H470.262V259.786H468.005Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.438 270.316C315.938 270.316 316.977 269.248 316.977 267.765C316.977 266.623 316.487 265.867 314.972 264.354C313.859 263.242 313.532 262.767 313.532 262.115C313.532 261.462 313.844 261.121 314.393 261.121C314.943 261.121 315.255 261.537 315.255 262.337V262.634L316.769 262.471V262.204C316.769 260.647 315.878 259.638 314.378 259.638C312.879 259.638 311.988 260.647 311.988 262.189C311.988 263.331 312.433 264.132 313.992 265.6C315.165 266.712 315.433 267.187 315.433 267.839C315.433 268.447 315.047 268.833 314.423 268.833C313.799 268.833 313.413 268.373 313.413 267.617V267.231L311.898 267.394V267.765C311.898 269.248 312.938 270.316 314.438 270.316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.5 270.316C321.999 270.316 323.039 269.248 323.039 267.765C323.039 266.623 322.549 265.867 321.034 264.354C319.92 263.242 319.594 262.767 319.594 262.115C319.594 261.462 319.906 261.121 320.455 261.121C321.005 261.121 321.316 261.537 321.316 262.337V262.634L322.831 262.471V262.204C322.831 260.647 321.94 259.638 320.44 259.638C318.94 259.638 318.049 260.647 318.049 262.189C318.049 263.331 318.495 264.132 320.054 265.6C321.227 266.712 321.495 267.187 321.495 267.839C321.495 268.447 321.108 268.833 320.485 268.833C319.861 268.833 319.475 268.373 319.475 267.617V267.231L317.96 267.394V267.765C317.96 269.248 319 270.316 320.5 270.316Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M503.776 270.316C505.276 270.316 506.315 269.248 506.315 267.765C506.315 266.623 505.825 265.867 504.31 264.354C503.197 263.242 502.87 262.767 502.87 262.115C502.87 261.462 503.182 261.121 503.731 261.121C504.281 261.121 504.592 261.537 504.592 262.337V262.634L506.107 262.471V262.204C506.107 260.647 505.216 259.638 503.716 259.638C502.216 259.638 501.325 260.647 501.325 262.189C501.325 263.331 501.771 264.132 503.33 265.6C504.503 266.712 504.771 267.187 504.771 267.839C504.771 268.447 504.385 268.833 503.761 268.833C503.137 268.833 502.751 268.373 502.751 267.617V267.231L501.236 267.394V267.765C501.236 269.248 502.276 270.316 503.776 270.316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.837 270.316C511.337 270.316 512.377 269.248 512.377 267.765C512.377 266.623 511.887 265.867 510.372 264.354C509.258 263.242 508.932 262.767 508.932 262.115C508.932 261.462 509.243 261.121 509.793 261.121C510.342 261.121 510.654 261.537 510.654 262.337V262.634L512.169 262.471V262.204C512.169 260.647 511.278 259.638 509.778 259.638C508.278 259.638 507.387 260.647 507.387 262.189C507.387 263.331 507.833 264.132 509.392 265.6C510.565 266.712 510.832 267.187 510.832 267.839C510.832 268.447 510.446 268.833 509.823 268.833C509.199 268.833 508.813 268.373 508.813 267.617V267.231L507.298 267.394V267.765C507.298 269.248 508.338 270.316 509.837 270.316Z",
    fill: "white"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M443.496 184.897H446.837V179.314H448.642L451.649 184.897H455.458L452.183 179.002C454.077 178.446 454.879 177.023 454.879 174.554C454.879 171.172 453.408 169.771 449.689 169.771H443.496V184.897ZM446.837 176.467V172.618H449.332C450.958 172.618 451.537 173.174 451.537 174.554C451.537 175.91 450.958 176.467 449.332 176.467H446.837Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M457.592 184.897H460.933V179.603H463.584C467.415 179.603 469.041 178.157 469.041 174.709C469.041 171.239 467.415 169.771 463.584 169.771H457.592V184.897ZM460.933 176.756V172.618H463.294C464.987 172.618 465.7 173.241 465.7 174.687C465.7 176.133 464.987 176.756 463.294 176.756H460.933Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M471.231 184.897H474.394V173.486L478.159 184.897H480.408L484.173 173.486V184.897H487.514V169.771H482.569L479.361 179.647L476.132 169.771H471.231V184.897Z",
    fill: "white"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "mask5",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 211,
    y: 292,
    width: 157,
    height: 53
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.65 293.413C211.65 292.861 212.098 292.413 212.65 292.413H366.575C367.128 292.413 367.575 292.861 367.575 293.413V343.316C367.575 343.869 367.106 344.316 366.553 344.316C249.457 344.204 215.963 324.894 212.055 322.348C211.791 322.176 211.65 321.887 211.65 321.572V293.413Z",
    fill: "#FAAC48"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.65 293.413C211.65 292.861 212.098 292.413 212.65 292.413H366.593C367.138 292.413 367.583 292.818 367.592 293.364C367.713 300.416 368.429 344.316 367.575 344.316C249.652 344.316 215.974 324.902 212.055 322.348C211.791 322.176 211.65 321.887 211.65 321.572V293.413Z",
    fill: "#FAAC48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.863 296.12L367.576 292.413L369.432 346.17L272.907 344.316C262.388 339.373 247.662 330.599 272.907 335.048C298.152 339.497 344.063 340.609 363.863 340.609V296.12Z",
    fill: "#DD871A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.65 292.413H371.288C372.313 292.413 369.432 292.413 367.575 292.413L363.863 296.12H215.363V320.105C216.079 320.635 217.311 321.361 219.225 322.233C221.71 323.366 225.198 324.678 229.869 326.091C239.209 328.915 253.192 332.111 273.179 335.068C274.193 335.218 274.893 336.16 274.743 337.173C274.593 338.186 273.649 338.885 272.635 338.735C252.526 335.76 238.356 332.53 228.793 329.639C224.013 328.194 220.362 326.826 217.684 325.606C215.062 324.412 213.214 323.289 212.194 322.271L211.65 321.728V292.413Z",
    fill: "#FFD5A0"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M263.916 322.071H265.921V316.22H269.618C273.16 316.22 274.675 314.841 274.675 311.594C274.675 308.346 273.16 306.944 269.618 306.944H263.916V322.071ZM265.921 314.396V308.769H269.485C271.824 308.769 272.67 309.569 272.67 311.594C272.67 313.618 271.824 314.396 269.485 314.396H265.921Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M280.917 322.338C282.543 322.338 283.79 321.693 284.792 320.247L284.859 322.071H286.53V310.593H284.57V318.044C283.723 319.735 282.654 320.536 281.273 320.536C279.892 320.536 279.224 319.757 279.224 317.955V310.593H277.263V318.133C277.263 320.892 278.489 322.338 280.917 322.338Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M290.232 322.071H292.193V305.832H290.232V322.071Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M299.608 322.338C302.637 322.338 304.197 321.136 304.197 318.823C304.197 316.643 303.038 315.664 299.964 315.331C297.848 315.108 297.069 314.686 297.069 313.64C297.069 312.595 297.96 311.994 299.564 311.994C301.212 311.994 302.036 312.639 302.036 313.862H303.952C303.952 311.549 302.437 310.326 299.586 310.326C296.735 310.326 295.153 311.571 295.153 313.796C295.153 315.842 296.267 316.732 299.274 317.088C301.501 317.355 302.281 317.844 302.281 318.979C302.281 320.069 301.39 320.669 299.608 320.669C297.692 320.669 296.757 320.002 296.757 318.69H294.886C294.886 321.114 296.445 322.338 299.608 322.338Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M311.414 322.338C314.176 322.338 315.892 321.092 316.048 318.645H314.154C314.021 319.891 313.107 320.647 311.37 320.647C309.32 320.647 308.385 319.624 308.385 317.377V316.865H316.137V315.197C316.137 312.038 314.421 310.326 311.281 310.326C308.14 310.326 306.425 312.038 306.425 315.197V317.466C306.425 320.625 308.184 322.338 311.414 322.338ZM308.385 315.242C308.385 313.039 309.298 312.016 311.325 312.016C313.33 312.016 314.243 313.039 314.243 315.242H308.385Z",
    fill: "black"
  })), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "mask6",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 382,
    y: 292,
    width: 157,
    height: 53
  }, /*#__PURE__*/React.createElement("path", {
    d: "M538.35 293.413C538.35 292.861 537.902 292.413 537.35 292.413H383.425C382.872 292.413 382.425 292.861 382.425 293.413V343.316C382.425 343.869 382.895 344.316 383.447 344.316C500.543 344.204 534.037 324.894 537.945 322.348C538.209 322.176 538.35 321.887 538.35 321.572V293.413Z",
    fill: "#FAAC48"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M538.35 293.413C538.35 292.861 537.902 292.413 537.35 292.413H383.407C382.862 292.413 382.417 292.818 382.408 293.364C382.287 300.416 381.571 344.316 382.425 344.316C500.348 344.316 534.026 324.902 537.945 322.348C538.209 322.176 538.35 321.887 538.35 321.572V293.413Z",
    fill: "#FAAC48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.137 340.609L428.831 339.497L434.4 344.316H382.425V292.413H538.35L534.637 296.12H386.137V340.609Z",
    fill: "#FFD5A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M534.638 320.183V296.12L538.35 292.413L538.351 322.476L537.324 322.989C522.165 330.558 503.327 338.744 428.943 343.201L428.721 339.5C501.105 335.163 520.238 327.311 534.638 320.183Z",
    fill: "#DD871A"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 428.831,
    cy: 341.35,
    rx: 1.85625,
    ry: 1.85369,
    fill: "#FFD5A0"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M442.523 322.338C446.065 322.338 447.847 320.87 447.847 317.912C447.847 315.153 446.465 313.908 442.812 313.441C440.251 313.107 439.315 312.395 439.315 310.882C439.315 309.348 440.451 308.502 442.523 308.502C444.617 308.502 445.619 309.348 445.619 311.105H447.624C447.624 308.146 445.931 306.678 442.59 306.678C439.182 306.678 437.333 308.191 437.333 311.083C437.333 313.685 438.625 314.864 442.1 315.331C444.884 315.709 445.864 316.466 445.864 318.09C445.864 319.691 444.75 320.514 442.545 320.514C440.251 320.514 439.07 319.602 439.07 317.778H437.065C437.065 320.826 438.914 322.338 442.523 322.338Z",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M454.271 322.071H456.053V320.381H454.739C453.425 320.381 453.091 320.003 453.091 318.512V312.195H455.92V310.593H453.091V307.568H451.331L451.175 310.593H449.148V312.195H451.131V318.49C451.131 321.004 452.066 322.071 454.271 322.071Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M461.479 322.338C463.15 322.338 464.442 321.693 465.377 320.514L465.444 322.071H467.115V314.575C467.115 311.728 465.645 310.326 462.615 310.326C459.742 310.326 458.182 311.594 457.982 314.086H459.898C459.964 312.684 460.922 312.017 462.548 312.017C464.33 312.017 465.155 312.84 465.155 314.619V315.242H462.392C459.163 315.242 457.648 316.532 457.648 318.824C457.648 321.07 459.118 322.338 461.479 322.338ZM461.769 320.648C460.321 320.648 459.608 319.98 459.608 318.779C459.608 317.489 460.455 316.866 462.459 316.866H465.155V318.49C464.464 319.891 463.306 320.648 461.769 320.648Z",
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M470.568 322.071H472.528V315.465C472.907 313.263 473.954 312.306 475.825 312.306H476.404V310.371H475.624C473.954 310.371 472.907 311.105 472.327 312.729L472.238 310.593H470.568V322.071Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M482.333 322.071H484.115V320.381H482.8C481.486 320.381 481.152 320.003 481.152 318.512V312.195H483.981V310.593H481.152V307.568H479.392L479.236 310.593H477.209V312.195H479.192V318.49C479.192 321.004 480.127 322.071 482.333 322.071Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcControlsPanel);
export default __webpack_public_path__ + "static/media/mc_controls_panel.783047b63247c3dd65e765b2621a3cec.svg";
export { ForwardRef as ReactComponent };